{
  "name": "sensika",
  "version": "2026.9.26",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --host=sensika-app.test",
    "start85": "ng serve --host=sensika85-app.test --configuration=development85",
    "start-dev": "ng serve --configuration=dev",
    "start-dev-no-debug": "ng serve --live-reload=false --configuration=dev-no-debug",
    "postinstall": "node scripts/build-info.mjs",
    "prebuild": "node scripts/build-info.mjs",
    "build": "ng build --configuration=production",
    "prebuild-test": "node scripts/build-info.mjs",
    "build-test": "ng build --configuration=test",
    "deploy:fe-test": "bash scripts/fe-test/deploy.sh",
    "watch": "ng build --watch --configuration development",
    "format": "prettier . --write",
    "scan:tokens": "node scripts/token-scan.mjs",
    "scan:cycles": "node scripts/import-cycles.mjs",
    "check:libs": "bash scripts/libs/consumer-check.sh",
    "test:rules": "node --test src/app/source-catalog/utils/*.test.ts",
    "test:keyword-list": "node --test src/app/connector-manager/utils/*.test.ts",
    "test:grid-return-state": "node --test projects/ag-grid-kit/src/utils/*.test.ts",
    "scan:i18n": "node scripts/i18n-scan.mjs",
    "scan:styles": "node scripts/style-audit.mjs",
    "build:grammar": "lezer-generator src/app/shared/components/query-editor/solr.grammar -o src/app/shared/components/query-editor/solr-parser.js"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.1.1",
    "@angular/cdk": "^22.1.1",
    "@angular/common": "^22.1.1",
    "@angular/compiler": "^22.1.1",
    "@angular/core": "^22.1.1",
    "@angular/forms": "^22.1.1",
    "@angular/localize": "^22.1.1",
    "@angular/platform-browser": "^22.1.1",
    "@angular/platform-browser-dynamic": "^22.1.1",
    "@angular/router": "^22.1.1",
    "@codemirror/lang-javascript": "^6.2.4",
    "@codemirror/language": "^6.12.1",
    "@codemirror/legacy-modes": "^6.5.2",
    "@codemirror/state": "^6.5.4",
    "@codemirror/view": "^6.39.15",
    "@floating-ui/dom": "^1.6.0",
    "@fontsource-variable/noto-sans": "^5.3.0",
    "@fortawesome/angular-fontawesome": "^5.1.0",
    "@fortawesome/fontawesome-free": "^7.1.0",
    "@fortawesome/fontawesome-svg-core": "^7.1.0",
    "@fortawesome/free-brands-svg-icons": "^7.1.0",
    "@fortawesome/free-regular-svg-icons": "^7.1.0",
    "@fortawesome/free-solid-svg-icons": "^7.1.0",
    "@highcharts/map-collection": "^2.3.2",
    "@lezer/generator": "^1.8.0",
    "@ngrx/effects": "^21.1.1",
    "@ngrx/operators": "^21.1.1",
    "@ngrx/store": "^21.1.1",
    "@ngrx/store-devtools": "^21.1.1",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@popperjs/core": "^2.11.8",
    "@swimlane/ngx-charts": "^25.0.0",
    "@tanstack/angular-query-experimental": "5.90.25",
    "ag-grid-angular": "~34.3.1",
    "ag-grid-community": "~34.3.1",
    "ag-grid-enterprise": "~34.3.1",
    "angular-shepherd": "^22.0.0",
    "angular-svg-icon": "^19.1.1",
    "codemirror": "^6.0.2",
    "colorjs.io": "^0.5.2",
    "date-fns": "^4.1.0",
    "gridstack": "^12.3.3",
    "highcharts": "^11.4.8",
    "highcharts-angular": "^3.1.2",
    "immer": "^10.2.0",
    "lodash-es": "^4.17.21",
    "ng-angular-popup": "^2.1.0",
    "ng-primitives": "^0.89.0",
    "ngx-cookie-service": "^22.0.0",
    "ngx-image-cropper": "^9.1.5",
    "ngx-quill": "^31.0.1",
    "ngx-toastr": "^20.0.5",
    "quill": "^2.0.3",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "video.js": "^8.24.0",
    "videojs-vjstranscribe": "^1.0.3",
    "videojs-youtube": "^3.0.1",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/core": "^22.1.7",
    "@angular-devkit/schematics": "^22.1.7",
    "@angular/build": "^22.1.7",
    "@angular/cli": "^22.1.7",
    "@angular/compiler-cli": "^22.1.1",
    "@types/node": "^24.10.0",
    "@types/resize-observer-browser": "^0.1.11",
    "@types/video.js": "^7.3.58",
    "@types/youtube": "^0.1.2",
    "ng-packagr": "^22.1.1",
    "prettier": "^3.6.2",
    "style-dictionary": "^4.4.0",
    "typescript": "~6.0.3"
  },
  "overrides": {
    "@hono/node-server": "^2.0.5",
    "shepherd.js": "15.3.0"
  },
  "allowScripts": {
    "@parcel/watcher@2.6.0": true,
    "lmdb@3.5.6": true,
    "msgpackr-extract@3.0.4": true,
    "esbuild@0.28.2": true,
    "style-dictionary@4.4.0": true,
    "@bundled-es-modules/glob@10.4.2": true
  },
  "engines": {
    "node": "^24.19.0",
    "npm": ">=11.17.0"
  },
  "volta": {
    "node": "24.19.0",
    "npm": "11.17.0"
  }
}
